import React, { useEffect, useState } from 'react'
import Images from '../../components/images';
import CustomLoader from '../../helper/CustomLoader';
import { _debounce, _throttle } from '../../Utilities/Utilities';
import { scorecardURL } from '../../WSHelper/WSConstants';
import InningsCollapse from './InningsCollapse';

//const CricketScorecard = (props, { history, match }) => {
 // console.log(props);
 // const { params: { matchId = 53274 } } = match;

const CricketScorecard = (props) => {

  useEffect(() => {
    fetchPost()
  }, []);

  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const [loader, setLoader] = useState(true);
  const fetchPost = async () => {
    setLoader(true);
    try {

      const response = await fetch(
        `${scorecardURL}/fantasy/cricket/scorecard/${props.matchId}`
      );
      const data = await response.json();
      //update the state
      setData(data.data);
      setLoader(false);
    } catch (error) {
      setLoader(false);
      setData(null);
      setError(error);
    }
  };


  const errorState = (data) => {
    return (
    <div className="web-container transparent-header lobby-web-container web-container-fixed scorecard">
      <div className="app-header-style hide-shadow"><div className='scorecard-header'>
        <div className='left-arrow-scorecard' onClick={() => props.closeModal()}>
          <a className="header-action"><i className="icon-close" style={{ color:'#FFFFFF' }}></i></a>
        </div>
        <div style={{ flex: "1 1 0%" }}>
          {/* <div className="app-header-text">{'something wentWtrong'}</div> */}
        </div>
        <div style={{
          paddingRight: "10px", width: " 60px"
        }}></div>
      </div>
      </div>
      <div>
        {
          !data && !error && <h1 className="status_note" style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            height: "80vh"

          }}>
            <p>
              Data not available currently
            </p>
            Please try again later.
          </h1>
        }
        {
          error && <h1 className="status_note" style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            height: "80vh"
          }} >
            <p>
              Something Went Wrong.
            </p>
            Please try again later.
          </h1>
        }
      </div>
    </div>)
  }


  return (
    <>
      <div className='reloadSingle'></div >
      {loader && <CustomLoader />}
      {!loader && error && errorState(data)}
      {!loader && !error && !data && errorState(data)}
      {data && (<div className="web-container transparent-header lobby-web-container web-container-fixed scorecard">
        {<div className="app-header-style hide-shadow">
          <div className='scorecard-header'>
          {<div className='left-arrow-scorecard' onClick={() => props.closeModal()}>
            <a className="header-action"><i className="icon-close" style={{ color:'#FFFFFF' }}></i></a>
            </div>}
          <div style={{ flex: "1 1 0%" }}>
            <div className="app-header-text">{data.title}</div>
          </div>
          <div style={{
            paddingRight: "10px", width: " 60px"
          }}>
            {data.match_status == 'Live' &&
              <img src={Images.REFRESH_ICON} alt="refresh" onClick={_debounce(() => {
                fetchPost()
              }, 1000)} />
            }
          </div>
        </div>
        </div>}
        <div style={{ marginTop:56 }}></div>
        <div>
          <div className="status_note">
            {data.status_note}
          </div>
          <div className="match_format">
            {data.match_format} | <span className={`${data.match_status}`}>{data.match_status}</span>
          </div>
        </div>
        <div style={{
          display: "flex",
          flexDirection: "column-reverse"
        }}>

          {data.innings.map((element, index) => <InningsCollapse data={element} key={index} />)}
        </div>
        <div style={{ marginBottom: "100px" }}></div>
      </div>)}
    </>
  )
}


export default CricketScorecard;